<template>
  <v-card v-if='loaded' class="flex d-flex flex-column mx-auto" elevation="5" :disabled='isSaving'>
    <v-container>
      <v-row justify="space-between">

        <v-col :cols="hasWarning() ? 11 : 12" align="center">
          <div class="title primary--text"> {{ getTranslatedName(competency.name) }}</div>
          <div class="subtitle-1">{{competency.category}}</div>
        </v-col>
        <v-col v-if='hasWarning()' cols='1' align='right'>
          <v-tooltip bottom>
            <template v-slot:activator='{on, attrs}'>
              <span v-bind='attrs' v-on='on'>
                <v-icon color='error'>mdi-alert-circle</v-icon>
              </span>
            </template>
            <span>{{$t('Warnings.unsavedCues')}}</span>
          </v-tooltip>
        </v-col>

        <v-col cols="12" align="start" v-if="competency.description">
          <p class="justify-start align-content-start mx-5" v-html="competency.description.replace(/\n/gi, '<br/>')"/>
        </v-col>

        <v-col cols="12">
          <v-row class="d-none d-md-flex" align="center" justify="center">
            <v-col v-for="s in scaleCriterions" :key="s.id" align="center" cols="2" class="" v-html="fancyPancyReplace(s.name)" />
          </v-row>

          <v-row class="d-md-none" align="center" justify="center">
            <v-col v-for="s in scaleCriterions" :key="s.id" align="center" cols="2" class="">
              {{s.value}}
            </v-col>
          </v-row>
          <v-radio-group :value="assessment.selectedValue" row @change="updateAssessment" :key='`${currentParticipant.id}_${competency.id}`'>
            <v-row align="center" justify="center">
              <v-col v-for="s in scaleCriterions" :key="s.id" align="center" cols="2" justify="center">
                <span class="d-none">{{s.value}}</span>
                <v-radio :value="s.value" class="justify-center"></v-radio>
                <!--<v-radio :label="s.value" :value="s.value" class="justify-center"></v-radio>-->
              </v-col>

            </v-row>
          </v-radio-group>

        </v-col>

      </v-row>

      <v-row class="mx-2" justify="space-between" v-if="competency.behavioralAnchors && competency.behavioralAnchors.length > 0">
        <v-expansion-panels hover elevation="1">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row no-gutters>
                <v-col cols="12" align="center">
                  <div class="primary--text">{{$i18n.t('AssessmentPage.cues')}}</div>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col align="center" class="cueContainer" v-for="(cueArea, index) in cueAreas" :key="`cueArea_${index}`" :style="`width: ${100 / cueAreaCount}%`">
                  <assessment-cue-selector v-for="cue in cueArea" :key="cue.id" :cue="cue" :selected="isCueSelected(cue.id)" @ki-cue-toggle="(val)=>toggleCue(competency, val)" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>

    </v-container>
  </v-card>
</template>

<script>
import ACTIONS from '@/storeActions';
import { v4 as uuid } from 'uuid';
import { mapGetters, mapState } from 'vuex';
import { generateOrUpdateCueAreas } from '@/libs/commonHelper';
import AssessmentCueSelector from './AssessmentCueSelector';

export default {
  name: 'AssessmentCompetencyCard',
  components: {
    AssessmentCueSelector,
  },
  props: {
    scaleCriterions: Array,
    competency: Object,
    matrix: Object
  },
  data() {
    return {
      loaded: false,
      cueAreas: [],
      cueAreaCount: 3,
      isSaving: false,
    };
  },
  watch: {
    competency() {
      if (this.competency.behavioralAnchors) {
        const { count, result } = generateOrUpdateCueAreas(this.competency.behavioralAnchors, 'area')
        this.cueAreaCount = count;
        this.cueAreas = result;
      }
    },
  },
  methods: {
    hasWarning() {
      return !this.assessment.id && !this.assessment.selectedValue && (Array.isArray(this.assessment.selectedCuesIds) && this.assessment.selectedCuesIds?.length > 0);
    },
    fancyPancyReplace(criterion) {
      switch (criterion) {
        case 'unterdurchschnittlich':
          return 'unter&shy;durch&shy;schnitt&shy;lich';
        case 'überdurchschnittlich':
          return 'über&shy;durch&shy;schnitt&shy;lich';
        case 'weit unterdurchschnittlich':
          return 'weit unter&shy;durch&shy;schnitt&shy;lich';
        case 'weit überdurchschnittlich':
          return 'weit über&shy;durch&shy;schnitt&shy;lich';
        case 'sehr weit unterdurchschnittlich':
          return 'sehr weit unter&shy;durch&shy;schnitt&shy;lich';
        case 'sehr weit überdurchschnittlich':
          return 'sehr weit über&shy;durch&shy;schnitt&shy;lich';
        default:
          return criterion;
      }
    },
    getTranslatedName(compName) {
      return compName === 'Subjektiver Gesamteindruck' ? this.$t('AssessmentPage.overallImpression') : compName;
    },
    isCueSelected(cueId) {
      return this.assessment.selectedCuesIds && this.assessment.selectedCuesIds.includes(cueId);
    },
    updateAssessment(evt) {
      console.log('update assessment')
      const payload = { ...this.assessment, modified: true };
      const self = this;
      this.assessment.selectedValue = evt;
      payload.selectedValue = evt;
      if (!payload.id && !payload.temporaryId) {
        payload.temporaryId = uuid();
        this.assessment.temporaryId = payload.temporaryId;
      }
      this.$emit('saveWithDelay', payload)
    },
    toggleCue(comp, cueId) {
      const payload = { ...this.assessment, modified: true };
      if (!payload.selectedCuesIds) payload.selectedCuesIds = [];

      if (payload.selectedCuesIds.includes(cueId)) {
        payload.selectedCuesIds = payload.selectedCuesIds.filter((cue) => cue !== cueId);
      } else {
        payload.selectedCuesIds.push(cueId);
      }

      if (!payload.id && !payload.temporaryId) {
        payload.temporaryId = uuid();
        this.assessment.temporaryId = payload.temporaryId;
      }
      if (payload.id || payload.selectedValue) {
        this.$emit('saveWithDelay', payload)
      }

      this.$store.dispatch(ACTIONS.SET_SINGLE_ASSESSMENT, payload);
    },
  },
  computed: {
    ...mapGetters(['currentObserver', 'currentParticipant']),
    ...mapState({
      assessments: (state) => state.assessments,
      competencyExerciseMatrix: (state) => state.runInfo.competencyExerciseMatrix
    }),
    assessment() {
      // return either the assessment or a predefined assessment placeholder
      return this.assessments.find((a) => a.matrixId === this.matrix.id && a.participantId === this.currentParticipant.id) || this.defaultAssessment;
    },
    defaultAssessment() {
      return {
        matrixId: this.matrix.id,
        participantId: this.currentParticipant.id,
        selectedValue: null,
        modified: true
      }

    },
    selectedCriterion() {
      return this.assessment?.selectedValue || null
    },
  },
  mounted() {
    if (this.competency && this.competency.behavioralAnchors) {
      const { count, result } = generateOrUpdateCueAreas(this.competency.behavioralAnchors, 'area')
      this.cueAreaCount = count;
      this.cueAreas = result;
    }
    this.loaded = true
  },
};
</script>

<style lang="scss" scoped>
@import '@/ci.scss';

.v-radio{
  display: block!important;
  margin-left: 16px!important;
}
.cueContainer{
  border-right: 1px dashed lightgray;
}
</style>
